import dompurify from 'dompurify';

const sanitizer = dompurify.sanitize;

function isString(possibleString) {
  return typeof possibleString === 'string';
}

export function safeHTML(unsafeContent) {
  const validContent = isString(unsafeContent);
  return validContent ? sanitizer(unsafeContent) : undefined;
}
